import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import notFoundImage from "../../assets/empty-state/404-not-found.png";

function RouterErrorFallback() {
  const navigate = useNavigate();

  // Generate random stars
  const stars = useMemo(
    () =>
      Array.from({ length: 80 }, (_, i) => ({
        id: i,
        delay: Math.random() * 5,
        duration: 4 + Math.random() * 6,
        size: 1 + Math.random() * 2,
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
      })),
    [],
  );

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-[#000002] w-full overflow-hidden">
      {/* Animated stars keyframes */}
      <style>{`
        @keyframes twinkle {
          0% { opacity: 0.2; transform: scale(1) translate(0, 0); }
          50% { opacity: 0.8; transform: scale(1.2) translate(10px, -15px); }
          100% { opacity: 0.2; transform: scale(1) translate(0, 0); }
        }
      `}</style>

      {/* Stars */}
      {stars.map((star) => (
        <div
          key={star.id}
          className="absolute rounded-full bg-white"
          style={{
            opacity: 0.7,
            width: `${star.size}px`,
            height: `${star.size}px`,
            top: star.top,
            left: star.left,
            animation: `twinkle ${star.duration}s ease-in-out ${star.delay}s infinite`,
            boxShadow: "0 0 4px rgba(255, 255, 255, 0.5)",
          }}
        />
      ))}

      {/* Background astronaut image */}
      <img
        src={notFoundImage}
        alt="404 Not Found"
        className="absolute w-[1600px] h-auto opacity-[0.85] z-0"
      />

      {/* Content overlay */}
      <div className="relative z-10 flex flex-col items-center justify-center text-center ml-[300px]">
        {/* 404 Title with glow */}
        <h1
          className="text-[180px] font-bold leading-none mb-4"
          style={{
            background: "linear-gradient(180deg, #c084fc 0%, #7c3aed 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            textShadow:
              "0 0 60px rgba(168, 85, 247, 0.6), 0 0 100px rgba(168, 85, 247, 0.4)",
            filter: "drop-shadow(0 0 30px rgba(168, 85, 247, 0.5))",
          }}
        >
          404
        </h1>

        {/* Subtitle */}
        <h2 className="text-white text-2xl font-semibold tracking-wider mb-6">
          PAGE NOT FOUND
        </h2>

        {/* Description */}
        <p className="text-gray-400 text-base max-w-md mb-8 leading-relaxed">
          The page you are looking for might have been removed, had its name
          changed, or is temporarily unavailable.
        </p>

        {/* GO HOME Button */}
        <button
          type="button"
          onClick={() => navigate("/")}
          className="px-12 py-3 bg-purple-600/80 text-white text-sm font-semibold tracking-widest border border-purple-500 rounded cursor-pointer  hover:bg-purple-500 hover:shadow-[0_0_20px_rgba(168,85,247,0.5)]"
        >
          GO HOME
        </button>
      </div>
    </div>
  );
}

export default RouterErrorFallback;
